import { formatDateTime, DateFormat } from 'src/compass/shared/util/casMoment';
import ICasRenderCellProps from '../ICasRenderCellProps';
import getCasTableCellValue from '../getCasTableCellValue';

export function CasRenderDateTime(props: ICasRenderCellProps) {
  return formatDateTime(getCasTableCellValue(props), DateFormat.MDY_HM);
}
